import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import ConfigTimeService from "services/ConfigTimeService";


let initialState = { list: [] };

export const getConfigTimes = createAsyncThunk(
  "configTime/getConfigTimes",
  async () => {
    const response = await ConfigTimeService.getconfigtime();
    return response?.results;
  }
);

export const updateConfigTimes = createAsyncThunk(
  "configTime/updateConfigTimes",
  async (body) => {

    const response = await ConfigTimeService.updateconfigtime(body);
    return response?.results;
  }
);


export const approveConfigTimes = createAsyncThunk(
  "configTime/approveConfigTimes",
  async (body) => {

    const response = await ConfigTimeService.approveConfigTimes(body);
    return response?.results;
  }
);



const configTimeSlice = createSlice({
  name: "configTime",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getConfigTimes, builder, ["list"]);
    LoadingAdapter.applyAsyncBuilder(updateConfigTimes, builder);
    LoadingAdapter.applyAsyncBuilder(approveConfigTimes, builder);

  },
});

export default configTimeSlice.reducer;

